import { call, put, takeLatest } from "redux-saga/effects";
import { onLoginUser, onLoginUserError, onLoginUserSuccess } from "../Store/Slices/loginSlice";
import { callLoginUserApi } from "../Context/loginUser";
import { onsaveuserData } from "../Store/Slices/utilitySlice";
function* LoginUser({payload}) {
  try {
    const loginUserResponse = yield call(callLoginUserApi, payload);
    if (loginUserResponse.httpStatusCode === "200" || loginUserResponse.httpStatusCode === 200) {
      yield put(
        onLoginUserSuccess({ 
          data: loginUserResponse.data,
          message: loginUserResponse.message,
          status_code: loginUserResponse.httpStatusCode
        })
      );

      yield put(onsaveuserData({userData:
         loginUserResponse.data}));
    } else {
      yield put(
            onLoginUserError({
          data: loginUserResponse.data || null,
          message: loginUserResponse.message || "Login failed",
          status_code: loginUserResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    yield put(onLoginUserError({ data: null, message, status_code: 400 }));
  }
}

  
export default function* loginSaga() {
  yield takeLatest(onLoginUser.type, LoginUser);
}
